import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable, of } from "rxjs";
import { retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class SubcategoriaService
  implements RequestCRUD<any, ResponseServiceModel>
{
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError("SubCategoria");
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SubcategoriaAdministrador/Paginado?PageNumber=${entry.numeroPagina}&PageSize=12`,
        entry
      )
      .pipe(retry(2));
  }
  update(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(
        `${this.API_URL}/SubcategoriaAdministrador/${entry.sub_categoria_id}`,
        entry
      )
      .pipe(retry(2));
  }

  actualizarSubcategoria(
    id: any,
    tipoSolicitud: any[]
  ): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(
        `${this.API_URL}/SubCategoriaTipoSolicitudAdministrador/Actualizar/${id}`,
        tipoSolicitud
      )
      .pipe(retry(2));
  }

  create(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SubcategoriaAdministrador/Crear`,
        entry
      )
      .pipe(retry(2));
  }

  createSubcategoria(
    id: any,
    tipoSolicitud: any[]
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SubCategoriaTipoSolicitudAdministrador/Crear/${id}`,
        tipoSolicitud
      )
      .pipe(retry(2));
  }
  obtenerActividadesEconomicas(value: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/ActividadEconomicaAdministrador/filtro`,
        value
      )
      .pipe(retry(2));
  }

  obtenerTipoSolicitud(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SubCategoriaTipoSolicitudAdministrador/ObtenerTipoSolicitud/${entry}`
      )
      .pipe(retry(2));
  }

  delete(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .delete<ResponseServiceModel>(
        `${this.API_URL}/SubcategoriaAdministrador/${entry.sub_categoria_id}`
      )
      .pipe(retry(2));
  }
  deleteTipoSubcategoria(id: any): Observable<ResponseServiceModel> {
    return this.http
      .delete<ResponseServiceModel>(
        `${this.API_URL}/SubCategoriaTipoSolicitudAdministrador/Eliminar/${id}`
      )
      .pipe(retry(2));
  }
  getCategoria(): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/Categoria`)
      .pipe(retry(2));
  }

  obtenerMensajeDenegacion(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SubcategoriaAdministrador/ObtenerMensajeDenegacion/${entry}`
      )
      .pipe(retry(2));
  }
  validarActividadesEconomicasCiiu(
    prestador_id: number,
    subCategoria_id: number,
    tipo_rnt: number
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/SubCategoria/VerificarActividadesEconomicas/`,
        {
          prestador_id,
          sub_categoria_id: subCategoria_id,
          tipo_rnt
        }
      )
      .pipe(retry(2));
  }
  getByCategoria(id: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/Subcategoria/PorCategoria/${id}`,

      )
      .pipe(retry(2));
  }
  getDescripcionCorrespondenciaCiiu(sub_categoria_id: number) {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/SubCategoria/${sub_categoria_id}/DescripcionCorrespondenciaCiiu`
      )
      .pipe(retry(2));
  }
}
